import React from 'react'
import { Link } from 'react-router-dom'
import DataTable from 'react-data-table-component';
import Loading from '../../../components/loading'

const TableSubscriptions = (props) => {
  const paginationOptions = { rowsPerPageText: 'Itens por página', rangeSeparatorText: 'de' }
  const columns = [
    {
      name: 'Aluno',
      selector: 'user.name',
      sortable: true,
      grow: 2
    },
    {
      name: 'Curso',
      selector: 'course.name',
      sortable: true,
      grow: 2
    },
    {
      name: 'Turma',
      selector: 'class_name',
      sortable: true,
      grow: 2
    },
    {
      name: 'Ações',
      cell: (item) => (
        <div>
          <Link to="#">
            <i className="material-icons text-danger rtd_button" onClick={() => props.confirmDelete(item)}>delete_forever</i>
          </Link>
        </div>
      ),
      button: true,
    },
  ]

  return (
    < div className="row" >
      <div className="col">
        <DataTable
          columns={columns}
          data={props.data.data}
          progressPending={props.progressPending}
          pointerOnHover
          highlightOnHover
          noDataComponent="Nenhum registro encontrado"
          onRowClicked={props.onRowClicked}
          progressComponent={<Loading />}
          pagination
          paginationServer
          paginationComponentOptions={paginationOptions}
          paginationPerPage={props.perPage}
          paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
          paginationTotalRows={parseInt(props.data.total)}
          onChangeRowsPerPage={props.handlePerRowsChange}
          onChangePage={props.onChangePage}
        />
      </div>
    </div >
  )
}

TableSubscriptions.defaultProps = {
  data: Array,
  progressPending: Boolean,
  onRowClicked: Function,
  paginationPerPage: Number,
  onChangeRowsPerPage: Function,
  onChangePage: Function
}

export default TableSubscriptions